import React, { useContext } from 'react';
import RichTextBlock from '@op/components/RichTextBlock';
import { SubmitValueType } from '@op/components/RichTextBlock/RichTextEditModal';
import { useExecutionRichText } from '../../hooks/useRichText';
import useLanguage from '@op/hooks/useLanguage';

import './index.scss';
import { WeeklyReportContext } from '../../../hooks/permission';
interface ExecutionAnalysisProps {
  filter: any;
}

export default function ExecutionAnalysis({ filter }: ExecutionAnalysisProps) {
  const { richText, modifyRichText, loading, isEmpty } = useExecutionRichText({
    filter,
    RichModuleKey: 'execute',
  });
  const { formatMessage } = useLanguage();
  const { canEditSummary } = useContext(WeeklyReportContext);

  return (
    <RichTextBlock
      contentCard
      tabs={richText}
      bodyStyle={{
        padding: '22px',
        borderRadius: '10px',
        backgroundColor: '#F5F5F8',
      }}
      isFull={false}
      empty={isEmpty}
      canEdit={canEditSummary}
      emptyHeight={148}
      loading={loading}
      loadingHeight={148}
      title={ formatMessage('Execution Progress') }
      onlyOneLanguage
      singleModel
      hasEmptyImg={false}
      bodyHeight={148}
      emptyProps={{
        hasImg: false,
        hasTitle: false,
        contentCard: true,
      }}
      onConfirm={(_item: SubmitValueType) => {
        const data = _item[0];
        return modifyRichText({
          id: Number(data.key),
          content: data.text,
        });
      }}
    ></RichTextBlock>
  );
}
